import React, { Component } from "react";
import "./index.css";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import axios from "axios";
const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});
class AttendanceCard extends Component {
  state = {
    att: true,
    attendence: [],
    school: [],
    userdata: [],
    loading: false,
    attendence_status: "",
  };
  componentDidMount = () => {
    this.fetch({
      school: this.props.user.user.school.id,
      student_info: this.props.data.id,
      class_name: this.props.data.student_class.id,
      section: this.props.data.section.id,
      date: this.props.match.params.date,
    });
  };

  fetch = (params = {}) => {
    this.setState({ loading: true });
    axios
      .get(`/api/attendence`, { params: { ...params }, type: "json" })
      .then((res) => {
        if (res.status === 200 && res.data.length > 0) {
          this.setState({
            attendence: res.data,
            attendence_status: res.data[0].attendence_status,
            loading: false,
          });
        } else {
          this.setState({
            attendence: [],
            attendence_status: "",
            loading: false,
          });
        }
      });
  };

  handleSubmit = (value) => {
    this.setState({
      attendence_status: value,
    });
    let form_data = new FormData();
    form_data.append("attendence_status", value);
    form_data.append("date", this.props.match.params.date);
    form_data.append(
      "month",
      new Date(this.props.match.params.date).getMonth() + 1
    );
    form_data.append(
      "year",
      new Date(this.props.match.params.date).getFullYear()
    );
    form_data.append("student_info", this.props.data.id);
    form_data.append("class_name", this.props.data.student_class.id);
    form_data.append("section", this.props.data.section.id);
    form_data.append("school", this.props.user.user.school.id);
    form_data.append("session", this.props.user.session.id);
    if (this.state.attendence.length > 0)
      axios
        .put(`/api/attendence/${this.state.attendence[0].id}`, form_data, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          if (response.status === 201) {
            this.fetch({
              school: this.props.user.user.school.id,
              student_info: this.props.data.id,
              class_name: this.props.data.student_class.id,
              section: this.props.data.section.id,
              date: this.props.match.params.date,
            });
          }
        })
        .catch((error) => {});
    else
      axios
        .post(`/api/attendence`, form_data, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          if (response.status === 201) {
            this.fetch({
              school: this.props.user.user.school.id,
              student_info: this.props.data.id,
              class_name: this.props.data.student_class.id,
              section: this.props.data.section.id,
              date: this.props.match.params.date,
            });
          }
        })
        .catch((error) => {});
  };

  render() {
    return (
      <div className="shadow-sm rounded p-2">
        <div className="d-flex align-items-center justify-content-between">
          <div className="">
            <div className="th-12 th-medium ">
              {this.props.data.user.first_name} {this.props.data.user.last_name}
            </div>
          </div>
          <div className="">
            <div className="th-10 ">Roll No. {this.props.data.roll_no}</div>
            <div className="th-10 ">
              Adm. No. {this.props.data.student.admission_no}
            </div>
            {/* <div
              className="th-att-img"
              style={{
                backgroundImage: `url('https://images.unsplash.com/photo-1601062087032-5f07e3304320?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1490&q=80')`,
              }}
            ></div> */}
          </div>
        </div>

        <form className="d-flex justify-content-between pt-2">
          <div class=" d-flex align-items-center">
            <input
              class="th-input-radio radio-danger"
              type="radio"
              name="present"
              checked={this.state.attendence_status === "present"}
              onClick={() => this.handleSubmit("present")}
            />
            <div class="pl-1 th-10 text-truncate">Present</div>
          </div>
          <div class="d-flex align-items-center">
            <input
              class="th-input-radio"
              type="radio"
              name="absent"
              checked={this.state.attendence_status === "absent"}
              onClick={() => this.handleSubmit("absent")}
            />
            <div class="pl-1 th-10 text-truncate">Absent</div>
          </div>
          <div class=" d-flex align-items-center">
            <input
              class="th-input-radio"
              type="radio"
              name="halfday"
              checked={this.state.attendence_status === "halfday"}
              onClick={() => this.handleSubmit("halfday")}
            />
            <div class="pl-1 th-10 text-truncate">Half Day</div>
          </div>
          <div class=" d-flex align-items-center">
            <input
              class="th-input-radio"
              type="radio"
              name="late"
              checked={this.state.attendence_status === "late"}
              onClick={() => this.handleSubmit("late")}
            />
            <div class="pl-1 th-10 text-truncate">Late</div>
          </div>
        </form>
      </div>
    );
  }
}
export default withRouter(connect(mapStateToProps)(AttendanceCard));
